<template>
  <!-- Login Section 01 -->
  <div class="login-section">
    <section class>
      <div class="container_1" >
        <div class="row justify-content-center">
          <div class="col-lg-12 order-lg-2">
            <div class="hero-image">
              <img src="/assets/exported/login.jpg" alt />
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container login_hero" style="height:100%">
      <form @submit.prevent method="post">
        <h2 class="forget_text">আপনি কি পাসওয়ার্ড ভুলে গেছেন?</h2>
        <div class="container">
          <input type="text" v-model="user_email" placeholder="আপনার ইমেইল লিখুন" />
          <!-- Error masaage -->
          <div
            class="error_body"
            v-if="typeof errormessage.errors != 'undefined' && emailError == true"
          >
            <ul v-if="typeof errormessage.errors.email != 'undefined'">
              <li
                v-for="email_id in errormessage.errors.email"
                :key="email_id.id"
                class="error_data"
              >{{email_id}}</li>
            </ul>
          </div>
          <!-- Error masaage end-->
          <div>
            <ul>
              <li class="error_data"></li>
            </ul>
          </div>
          <div class="log_button">
            <button @click="submitEmail()" type="submit">পাঠিয়ে দিন</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert";
import axios from "axios";
export default {
  name: "",
  data() {
    return {
      user_email: "",
      error: [],
      errors: [],
      email: [],
      message: [],
      errormessage: [],
      emailError: false,
    };
  },
  methods: {
    submitEmail() {
      axios
        .post(this.$root.API_BASE_URL + "password-reset", {
          email: this.user_email,
        })
        .then((response) => {
          // Response received From Server
          // this.isLoading = false;
          this.$router.push("/change_success");
          console.log(response.data);
          return;
        })
        .catch((error) => {
          //offline Status
          if (navigator.onLine) {
            //this.errors.push(error.response.data.errors.email[0]);
            this.errormessage = error.response.data;
            if (typeof this.errormessage.errors.email != "undefined") {
              this.emailError = true;
            }
            console.log("ERRRR:: ", error.response.data);
          } else {
            swal({
              text: "আপনার ইন্টারনেট কানেকশনটি একটিভেট করুন",
              buttons: {
                confirm: { text: "ঠিক আছে" },
              },
            });
            //this.connectionStatus = "Unable to connect to internet.";
          }
        });
    },
  },
};
</script>
<style scoped>
.error {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  color: red;
}
.forget_text {
  text-align: center;
  font-size: 28px;
  color: #000;
}
::-webkit-input-placeholder {
  font-size: 16px;
  color: rgb(20, 20, 20);
  font-weight: 600;
}
::-ms-input-placeholder {
  font-size: 16px;
  color: rgb(20, 20, 20);
  font-weight: 600;
}
::placeholder {
  font-size: 16px;
  color: rgb(20, 20, 20);
  font-weight: 600;
}
@media screen and (max-width: 768px) {
  .error {
    font-size: 18px;
  }
  .forget_text {
    text-align: center;
    font-size: 22px;
    color: #000;
  }
}
</style>
